import { ENVIRONMENT, PLATFORM } from '@aws';
import { UserProfileData } from '@state/types';

export const getProfileImage = (profileImage: UserProfileData['profile_image']): string => {
  return `${PLATFORM[ENVIRONMENT].profile_url}/${profileImage ?? ''}`;
};
